<style scoped>
.dialog-close {
  margin-top: -10px;
  margin-right: -10px;
  padding: 10px;
}
</style>

<template>
  <v-card-title>
    <div>
      <slot>
        <span v-t="title" />
      </slot>
    </div>
    <v-spacer />
    <v-icon aria-label="Close" @click="$emit('close')" color="#000" class="dialog-close">
      mdi-close
    </v-icon>
  </v-card-title>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: null,
    },
  },
};
</script>
